/*
 *   File : bank-detail.js
 *   Author : https://evoqins.com
 *   Description : Bank detail  modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React from 'react';

//Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';

//Style
import style from "../../Style/Component/modal.module.scss";
import { Chip } from '../Others';

const BankDetailModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("bank-detail-close");
        button.click();
        props.handleClose();
    };


    return (
        <div className="modal fade "
            id="bank-detail"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="BankDetailModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered ${props.type === 2 ? 'modal-lg' : style.e_push_notification_modal_width} modal-dialog-scrollable border-radius-28`}>
                <span id='bank-detail-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content border-radius-28  border-0`}>
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top  padding-20px-bottom">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            View Bank details
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`${props.button !== true ? 'padding-32px-bottom ' : 'padding-20px-top  pb-0'} modal-body px-0`}>

                        <>
                            <div className='padding-32px-lr'>
                                <div className='padding-24px-all   justify-content-between e-bg-magnolia border-radius-16 e-border-1px-blue-violet '>
                                    <div className='d-flex e-border-bottom-1px-platinum-light  gap-52px'>

                                        <div className=''>
                                            <div className='padding-8px-bottom e-primary-font e-font-weight-400 e-font-14 line-height-16px  e-text-dark-silver'>Account type</div>
                                            <div className='e-primary-font  e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>Savings</div>
                                        </div>
                                        <div className=''>
                                            <div className='padding-8px-bottom e-primary-font e-font-weight-400 e-font-14 line-height-16px  e-text-dark-silver'>Bank name</div>
                                            <div className='e-primary-font  e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>HDFC bank</div>
                                        </div>
                                        <div className='pb-3'>
                                            <div className='padding-8px-bottom e-primary-font e-font-weight-400 e-font-14 line-height-16px  e-text-dark-silver'> IFSC code</div>
                                            <div className='e-primary-font  e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>HDFC00001234</div>
                                        </div>
                                    </div>



                                    <div className='d-flex  pb-3 gap-52px pt-3 e-border-bottom-1px-platinum-light'>

                                        <div className=''>
                                            <div className='padding-8px-bottom e-primary-font e-font-weight-400 e-font-14 line-height-16px  e-text-dark-silver'>Account number</div>
                                            <div className='e-primary-font  pt-2 e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>345678976</div>
                                        </div>

                                        <div>
                                            <div className=' e-primary-font padding-8px-bottom e-font-weight-400 e-font-14 line-height-16px  e-text-dark-silver'>KYC verification status</div>

                                            <Chip label='KYC verified'
                                                className='e-text-dark-gray e-bg-light-green padding-8px-lr  p-0' />
                                        </div>

                                    </div>




                                    <div className=''>
                                        <div className='padding-8px-bottom pt-3 e-primary-font e-font-weight-400 e-font-14 line-height-16px  e-text-dark-silver'>Account proof</div>

                                        <div className='e-modal-shadow'>
                                            <img src={require("../../Assets/Image/Document/bank-details.png")}
                                                draggable={false}
                                                className='w-100 h-100'
                                                alt='document' />
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </>

                    </div>
                </div>
            </div>
        </div >
    )
}

export default BankDetailModal;

BankDetailModal.defaultProps = {
    handleClose: () => { },
    type: 1,
}